import React from 'react';


export default function FichaDocumento({ documento }) {
    return (
        <div className='m-4' dangerouslySetInnerHTML={{ __html: documento.conteudo }}>

        </div>
    )
}